(function() {
  function showBadge(badgeArea) {
    if (badgeArea.querySelector('.badge-new-color-js')) return;
    var span = document.createElement('span');
    span.className = 'badge badge-new badge-new-color-js';
    span.style.backgroundColor = '#151922';
    span.style.color = '#fff';
    span.textContent = 'NEW COLOR';
    badgeArea.prepend(span);
  }

  function hideBadge(badgeArea) {
    var existing = badgeArea.querySelector('.badge-new-color-js');
    if (existing) existing.remove();
  }

  document.addEventListener('change', function(e) {
    var input = e.target;
    if (input.closest('header') || input.closest('nav')) return;
    if (!input.matches('input')) return;

    var selectedValue = input.value;
    var badgeArea, productId;
    var card = input.closest('.card-product');

    if (card) {
      var priceEl = card.querySelector('[data-product-id]');
      if (!priceEl) return;
      productId = priceEl.getAttribute('data-product-id');
      badgeArea = card.querySelector('.badges');
    } else {
      if (!input.name || !input.name.includes('product_variant_picker')) return;
      var section = document.querySelector('section[data-product]');
      if (!section) return;
      productId = section.getAttribute('data-product');
      badgeArea = section.querySelector('.badges');
    }

    if (!badgeArea || !productId) return;

    var options = (window.newColorOptions && window.newColorOptions[productId]) || [];
    if (options.indexOf(selectedValue) !== -1) {
      showBadge(badgeArea);
    } else {
      hideBadge(badgeArea);
    }
  });

  function initBadges() {
    // PDPのLiquidバッジを削除（JSで制御するため）
    var pdpSection = document.querySelector('section[data-product]');
    if (pdpSection) {
      pdpSection.querySelectorAll('.badges .badge-new:not(.badge-new-color-js):not(.badge-tag)').forEach(function(el) {
  el.remove();
});
    }

    // 検索一覧カード
    document.querySelectorAll('.card-product').forEach(function(card) {
      var priceEl = card.querySelector('[data-product-id]');
      if (!priceEl) return;
      var productId = priceEl.getAttribute('data-product-id');
      var checked = card.querySelector('.color-swatch-list input[type="radio"]:checked');
      if (!checked) return;
      var options = (window.newColorOptions && window.newColorOptions[productId]) || [];
      var badgeArea = card.querySelector('.badges');
      if (!badgeArea) return;
      if (options.indexOf(checked.value) !== -1) showBadge(badgeArea);
    });

    // PDP
    if (pdpSection) {
      var productId = pdpSection.getAttribute('data-product');
      var checked = pdpSection.querySelector('input[name*="product_variant_picker"]:checked');
      if (checked) {
        var options = (window.newColorOptions && window.newColorOptions[productId]) || [];
        var badgeArea = pdpSection.querySelector('.badges');
        if (badgeArea && options.indexOf(checked.value) !== -1) showBadge(badgeArea);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBadges);
  } else {
    initBadges();
  }
})();
